/**
 * API Error Code Constants and Mappings
 * Maps API error codes to user-friendly i18n keys
 */

// API Error Codes from backend
export const API_ERROR_CODES = {
	// HTTP Status Codes
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	INTERNAL_SERVER_ERROR: 500,
	SERVICE_UNAVAILABLE: 503
} as const

// Map error codes to i18n message keys
export const ERROR_CODE_MESSAGES: Record<number, string> = {
	// HTTP Status Codes
	[API_ERROR_CODES.BAD_REQUEST]: 'errors.bad_request',
	[API_ERROR_CODES.UNAUTHORIZED]: 'errors.unauthorized',
	[API_ERROR_CODES.FORBIDDEN]: 'errors.forbidden',
	[API_ERROR_CODES.NOT_FOUND]: 'errors.not_found',
	[API_ERROR_CODES.INTERNAL_SERVER_ERROR]: 'errors.internal_server_error',
	[API_ERROR_CODES.SERVICE_UNAVAILABLE]: 'errors.service_unavailable',

	// Default fallback
	0: 'errors.generic_message'
}

// Whitelist for API error titles that are safe to show users in production
export const SAFE_ERROR_TITLES = [
	// Role error titles
	'Route not found',
	'Role not found', // TODO verify BE response
	'Cannot delete system role', // TODO verify BE response
	'Cannot modify system role', // TODO verify BE response
	'Role is assigned to users and cannot be deleted', // TODO verify BE response
	'Role is assigned to users', // TODO verify BE response
	'Role is in use', // TODO verify BE response

	// Permission error titles
	'Permission already assigned to this role', // TODO verify BE response
	'Permission already assigned', // TODO verify BE response
	'Permission not found', // TODO verify BE response
	'Insufficient permissions', // TODO verify BE response

	// General error titles
	'Forbidden', // TODO verify BE response
	'Unauthorized', // TODO verify BE response
	'Not found', // TODO verify BE response
	'Bad request' // TODO verify BE response
]

// Whitelist for API error messages that are safe to show users in production
export const SAFE_ERROR_MESSAGES = [
	// Role error messages
	'Role name is required', // verified
	'Role with this name already exists', // verified
	'Role not found', // TODO verify BE response
	'Cannot delete system role', // TODO verify BE response
	'Cannot modify system role', // TODO verify BE response
	'Role is assigned to users and cannot be deleted', // TODO verify BE response
	'Role is assigned to users', // TODO verify BE response
	'Role is in use', // TODO verify BE response

	// Permission error messages
	'Permission name is required', // TODO verify BE response
	'Permission already assigned to this role', // TODO verify BE response
	'Permission already assigned', // TODO verify BE response
	'Permission not found', // TODO verify BE response
	'Insufficient permissions', // TODO verify BE response

	// General error messages
	'Forbidden', // TODO verify BE response
	'Unauthorized', // TODO verify BE response
	'Not found', // TODO verify BE response
	'Bad request' // TODO verify BE response
]

// Helper function to check if an error code is retryable for future enhancements
export const isRetryableError = (code: number): boolean => {
	return ([
		API_ERROR_CODES.SERVICE_UNAVAILABLE,
		API_ERROR_CODES.INTERNAL_SERVER_ERROR
	] as number[]).includes(code)
}

// Helper function to check if error requires re-authentication for future enhancements
export const requiresReauth = (code: number): boolean => {
	return ([
		API_ERROR_CODES.UNAUTHORIZED
	] as number[]).includes(code)
}
